import {
  Box, Typography, Button, IconButton
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';
import { useLanguage } from '../../../../context/language/language';
import { TitleModal } from '../../../MyAccount/common';
import { choiceSelectionModalSize } from '../modalSize';
import { getImageURL } from '../../../../utils/getImageURL';
import useDeliveryData from '../../../common/hook/useDeliveryData';
import { getSearchQueryParams } from '../../../../constant/urlPattern';
import WEBSITE_CODE from '../../../../constant/common/websiteCode';
import { ModalInfo } from '../../../common';
import useCustomerAddressList from '../../../common/hook/useCustomerAddressList';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import useAuthentication from '../../../common/hook/useAuthentication';

const Icon = getImageURL('/icon/clear-cart.svg');

const IconBtn = styled(IconButton)(({ theme }) => ({
  alignSelf: 'flex-end',
  width: 44,
  height: 44,
  backgroundColor: theme.colors.grey75,
  marginBottom: -15,

  ...theme.isMobile && {
    display: 'none',
  },
}));

const CustomTitleModal = styled(TitleModal)(({ theme }) => ({
  ...theme.fonts.header3,
}));

const BtnCancel = styled(Button)(({ theme }) => ({
  width: '100%',
  marginRight: 8,
  backgroundColor: theme.colors.grey75,
  height: 44,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header6,
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  width: '100%',
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  height: 44,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header6,

  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      width: choiceSelectionModalSize.width,
      padding: 24,
      boxSizing: 'border-box',
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 12
    },
  }
}));

function DifferentStoreTypeDialog(props) {
  const word = useLanguage();
  const classes = useStyle();
  const deliveryControl = useDeliveryControlFlow();
  const searchQueryParams = getSearchQueryParams();
  const adsWebsiteCode = searchQueryParams.websiteCode;
  const adsStoreType = adsWebsiteCode?.includes('_gf') ? 'go_fresh' : adsWebsiteCode?.includes('_hy') ? 'hyper' : undefined;
  const isJustBrowsing = WEBSITE_CODE.includes(adsWebsiteCode);
  const storeType = isJustBrowsing ? adsStoreType : undefined;
  const deliveryData = useDeliveryData();
  const customerAddress = useCustomerAddressList();
  const addressList = customerAddress.addressList;
  const defaultAddress = addressList?.find((address) => address?.isDefault === true);
  const selectedStoreId = deliveryData?.activeStore?.storeId;
  const [init, setInit] = useState(false);
  const { isLoggedIn } = useAuthentication();

  useEffect(() => {
    if (isLoggedIn) {
      customerAddress.getAddress();
    }
    deliveryControl.setFromDifferentStoreType(true);
    setInit(true);
  }, []);

  useEffect(() => {
    deliveryData.updateForm('filter', { storeType });
  }, [storeType]);

  useEffect(() => {
    if (init && _.isEmpty(selectedStoreId)) {
      if (isLoggedIn) {
        if (!customerAddress?.isProcess && customerAddress?.dataCompleted) {
          props.onNext({ adsStoreType, defaultAddress });
        }
      } else {
        props.onNext({ adsStoreType });
      }
    }
  }, [init, customerAddress?.isProcess, customerAddress?.dataCompleted]);

  if (_.isEmpty(selectedStoreId)) {
    return null;
  }
  return (
    <ModalInfo
      isOpen={deliveryControl.showModal}
      title={word('Product.Missing.Promotion')}
      description={word('Product.Missing.Promotion.Description')}
      type="info"
      showCancel
      showIcon
      cancelText={word('General.Cancel')}
      labelText={word('Store.ChangeStore.Button')}
      onClose={props.onBack}
      onConfirm={props.onNext}
    />
  );
}

export default DifferentStoreTypeDialog;
